import indian_flag from "../../static/images/icons8-india-48.png"

export const LanguageTab = ()=>{
    return(
        <>
            <div className="amazon-lanuage-tab px-3 text-white">
                <img src={indian_flag} alt="" />
                <span className="px-1">EN</span>
            </div>
        </>
    )
}
